<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<div class="p-4">
  <h2>Reservations</h2>

  <div class="grid mb-3">
    <div class="col-12 md:col-4">
      <span class="p-float-label" style="min-width:260px;">
        <p-dropdown
          [options]="properties"
          [optionLabel]="'propertyCode'"
          [optionValue]="'shortTermRentalId'"
          [(ngModel)]="selectedShortTermRentalId"
          [filter]="true"
          filterBy="propertyCode"
          [showClear]="true"
          placeholder="Filter by Property">
        </p-dropdown>
        <label>Filter by Property</label>
      </span>
    </div>
  </div>

  <p-table #dt [value]="filteredRows" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,50,100]">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 200px;">
          Create Date
          <br>
            <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'createDate', 'contains')" placeholder="Filter" style="width:100%;">
          </th>
          <th style="width: 160px;">
            ShortTermRental ID
            <br>
              <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'shortTermRentalId', 'equals')" placeholder="Filter" style="width:100%;">
            </th>
            <th style="width: 160px;">
              Reservation ID
              <br>
                <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'reservationId', 'contains')" placeholder="Filter" style="width:100%;">
              </th>
              <th style="width: 140px;">
                Status
                <br>
                  <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'queueStatus', 'contains')" placeholder="Filter" style="width:100%;">
                </th>
                <th>
                  Result
                  <br>
                    <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'testResultDesc', 'contains')" placeholder="Filter" style="width:100%;">
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr>
                  <td>{{row.createDate | date:'short'}}</td>
                  <td>{{row.shortTermRentalId}}</td>
                  <td>
                    @if (row.orderId) {
                      <a [href]="'https://admin.kbmhawaii.com/order/' + row.orderId" target="_blank" rel="noopener noreferrer">
                        {{row.reservationId}}
                      </a>
                    } @else {
                      {{row.reservationId}}
                    }
                  </td>
                  <td>{{row.queueStatus}}</td>
                  <td>{{row.testResultDesc}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>


